var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"ProductQuoteCreate"}},[_c('ProductForm',{attrs:{"user":_vm.user,"submitForm":_vm.addRow,"buttonText":"Guardar","hasQuote":"true"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }